<ins-creator-action-panel
  title="Submit content"
  subtitle="Start filming content and upload videos here."
  [(expanded)]="expanded">
  @if (userVideoUploadRunning()) {
    <div class="flex flex-col items-center gap-3 py-2 text-center">
      <p class="m-0 text-sm font-medium text-primary">Uploading…</p>
      <p class="m-0 text-xs text-secondary">
        @if (uploadPercentage() === 0) {
          Preparing…
        } @else {
          {{ uploadPercentage() }}%
        }
      </p>
      <div class="h-2 w-full overflow-hidden rounded-full bg-zinc-200 dark:bg-zinc-700">
        <div class="h-2 rounded-full bg-accent" [style]="uploadProgressWidth()"></div>
      </div>
    </div>
  } @else {
    <div class="flex flex-col gap-4">
      <label class="inline-flex w-full cursor-pointer items-center justify-center primary-button">
        Upload videos
        <input
          type="file"
          accept="video/*"
          class="sr-only"
          (change)="onFileSelected($event)" />
      </label>

      @if (loadingState() === 'loading') {
        <p class="m-0 text-sm text-secondary">Loading videos…</p>
      } @else if (loadingState() === 'error') {
        <p class="m-0 text-sm text-red-600" role="alert">Failed to load videos.</p>
      } @else if ((videos() ?? []).length === 0) {
        <app-empty-state title="No videos yet" description="Uploaded videos will appear here." />
      } @else {
        <ul class="m-0 flex list-none gap-3 overflow-x-auto p-0">
          @for (video of videos() ?? []; track video.id) {
            <li class="relative w-24 shrink-0">
              @if (video.status === VideoStatusEnum.Accepted) {
                <span
                  class="absolute top-1 right-1 z-10 inline-flex rounded-full bg-green-100 px-1 py-1 text-green-700"
                  aria-label="Approved">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    class="size-4"
                    aria-hidden="true">
                    <path
                      fill-rule="evenodd"
                      d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                      clip-rule="evenodd" />
                  </svg>
                </span>
              }

              <div class="overflow-hidden rounded-lg">
                <atom-video-thumbnail
                  [videoId]="video.id"
                  [videoUrl]="video.fullUrl"
                  [videoFormat]="video.videoFormat"
                  [thumbnailURL]="video.thumbnailURL ?? undefined"
                  [cdnKey]="video.thumbnailCdnKey ?? undefined"
                  thumb_cdn_size="gallery_sm"
                  (thumbnailPersisted)="onThumbnailPersisted($event.videoId, $event.thumbnailURL)" />
              </div>

              <p class="m-0 mt-2 truncate text-xs text-primary">{{ video.videoName }}</p>
              <p class="m-0 text-[10px] text-secondary">
                {{ formatService.getTimeSinceUpdated(video.createdDate) }}
              </p>
            </li>
          }
        </ul>
      }
    </div>
  }
</ins-creator-action-panel>
